module.exports = __webpack_public_path__ + "img/logo-innovative-insulation-green-transparent.2c18466e.png";